// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import Select from "react-select";
import {
  dummyimage,
  morning_slot,
  new_edit,
  night_slot,
} from "../../assets/img";
import DragAndDrop from "./DragAndDrop";
import TimeSlotSelectionPopup from "./TimeSlotSelectionPopup";

let Room = {
  availability: "",
  primaryImage: null,
  images: [],
  deletedImageIds: [],
  timeSlots: [],
};

const NearByLocation = ({
  edit,
  type,
  formData,
  errors,
  handleChange,
  optionsList,
  handleDropdownChange,
  customStyles,
  setFormData,
  timeSlots,
}) => {
  const [selectedSlot, setSelectedSlot] = useState({
    slot: null,
    basePrice: "",
  });
  const [activeId, setActiveId] = useState(null);
  const activeCat =
    formData?.roomCategories?.find((c) => c.value === activeId) ||
    formData?.roomCategories?.[0];
  const key = activeCat?.value;
  const [slotCatKey, setSlotCatKey] = useState(null);
  const [editingSlotId, setEditingSlotId] = useState(null);
  const room = formData?.roomDetails?.[key] || Room;
  const [nearby, setNearby] = useState({ name: "", distance: "" });
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (timeSlots?.[0]?.id) {
      setSelectedSlot((prev) => ({ ...prev, slot: timeSlots[0]?.id }));
    }
  }, []);

  const imgRef = useRef(null);

  const handleLocAdd = () => {
    if (!nearby?.name) {
      toast.error("Enter Locations");
      return;
    }
    if (!nearby?.distance) {
      toast.error("Enter Distance");
      return;
    }
    handleDropdownChange("nearby_locations", [
      ...formData?.nearby_locations,
      nearby,
    ]);
    setNearby({ name: "", distance: "" });
  };

  const updateRoom = (field, value) => {
    if (key === undefined) return; // was: if (!key) return;
    setFormData((prev) => {
      const current = prev.roomDetails?.[key] || Room;
      const next = typeof value === "function" ? value(current[field]) : value;
      return {
        ...prev,
        roomDetails: {
          ...prev.roomDetails, // was: ...prev.Room
          [key]: { ...current, [field]: next },
        },
      };
    });
  };

  const openSlotPopup = (slotToEdit) => {
    if (key === undefined) return toast.error("Select a room category first");
    const existing = formData?.roomDetails?.[key]?.timeSlots || [];

    if (slotToEdit) {
      setSelectedSlot({
        slot: slotToEdit.slot,
        basePrice: String(slotToEdit.basePrice),
      });
      setEditingSlotId(slotToEdit.slot);
    } else {
      const firstFree = timeSlots?.find(
        (t) => !existing.some((s) => s.slot === t.id),
      );
      if (!firstFree)
        return toast.error(
          "All time slots are already added for this category",
        );
      setSelectedSlot({ slot: firstFree.id, basePrice: "" });
      setEditingSlotId(null);
    }
    setSlotCatKey(key);
    setOpen(true);
  };

  const handleSaveSlot = () => {
    if (slotCatKey === null || slotCatKey === undefined)
      return toast.error("Select a room category first");
    if (!selectedSlot.slot) return toast.error("Select a slot duration");

    const price = Number(selectedSlot.basePrice);
    if (!selectedSlot.basePrice || Number.isNaN(price) || price <= 0)
      return toast.error("Enter a valid base price");

    const existing = formData?.roomDetails?.[slotCatKey]?.timeSlots || [];
    if (
      existing.some(
        (s) => s.slot === selectedSlot.slot && s.slot !== editingSlotId,
      )
    )
      return toast.error("This slot is already added for this category");

    const info = timeSlots?.find((s) => s.id === selectedSlot.slot);
    const newSlot = {
      slot: selectedSlot.slot,
      basePrice: price,
      label: info?.display_name?.trim() || "-",
      start_time: info?.start_time,
      end_time: info?.end_time,
      timeslot_type: info?.timeslot_type,
    };

    setFormData((prev) => {
      const cur = prev.roomDetails?.[slotCatKey] || Room;
      const list = cur.timeSlots || [];
      const nextList =
        editingSlotId !== null
          ? list.map((s) => (s.slot === editingSlotId ? newSlot : s)) // replace in place
          : [...list, newSlot];
      return {
        ...prev,
        roomDetails: {
          ...prev.roomDetails,
          [slotCatKey]: { ...cur, timeSlots: nextList },
        },
      };
    });

    setOpen(false);
  };

  const handleDeleteSlot = (slotId) =>
    updateRoom("timeSlots", (list = []) =>
      list.filter((s) => s.slot !== slotId),
    );

  const handleRoomPrimaryImage = (e) => {
    const file = e.target.files[0];
    if (file)
      updateRoom("primaryImage", { file, preview: URL.createObjectURL(file) });
  };

  const handleLocDelete = (location_del) => {
    let filtered = formData?.nearby_locations?.filter(
      (item) => item !== location_del,
    );
    handleDropdownChange("nearby_locations", filtered);
  };
  console.log("near by", nearby);
  return (
    <div className="w-100">
      <div className="w-100 d-flex gap-5">
        <div className="col-md-5 ">
          <div className="d-flex ac-jb">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Near By Locations<span style={{ color: "red" }}>*</span>
            </p>
            {edit && (
              <button
                disabled={!edit}
                onClick={() => {
                  handleLocAdd();
                }}
                className="add-btn p-1"
                style={{ width: "80px", height: "30px" }}
              >
                add
              </button>
            )}
          </div>
          <div className="d-flex gap-3 mt-3">
            <div>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 sec">
                Location
              </p>
              <input
                className="input-box"
                name="propertyName"
                value={nearby?.name}
                readOnly={!edit}
                onChange={(e) =>
                  setNearby((prev) => ({ ...prev, name: e.target.value }))
                }
                type="text"
                placeholder="Location"
              />
              {errors.location && <p className="err">{errors.location}</p>}
            </div>
            <div>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 sec">
                Distance
              </p>
              <input
                className="input-box"
                name="propertyName"
                value={nearby?.distance}
                readOnly={!edit}
                onChange={(e) =>
                  setNearby((prev) => ({ ...prev, distance: e.target.value }))
                }
                type="number"
                placeholder="Distance"
              />
              {errors.location && <p className="err">{errors.distance}</p>}
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Age<span style={{ color: "red" }}>*</span>
          </p>
          <select
            value={formData.age}
            disabled={!edit}
            onChange={handleChange}
            className="input-box"
            name="age"
            id=""
          >
            <option value={""}>select</option>
            {optionsList?.ageList?.map((item) => (
              <option value={item?.value}>{item?.label}</option>
            ))}
          </select>
          {errors.age && <p className="err">{errors.age}</p>}
        </div>
      </div>
      {formData?.nearby_locations?.length > 0 && (
        <ul className="d-flex gap-3 flex-wrap mt-3 w-100">
          {formData?.nearby_locations?.map((item, index) => {
            return (
              <li key={index}>
                <div
                  className="input-box d-flex ac-jb"
                  style={{ width: "200px", position: "relative" }}
                >
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ">
                    {item.name}{" "}
                  </p>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ">
                    {item.distance} km
                  </p>
                  {edit && (
                    <CancelIcon
                      onClick={() => handleLocDelete(item)}
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-10px",
                        height: "20px",
                      }}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      <div className="w-100 mt-5">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
          Description (optional)
        </p>
        <textarea
          className="roles-input w-100 p-2"
          name="description"
          value={formData.description}
          readOnly={edit ? false : true}
          onChange={handleChange}
          type="text"
          placeholder="Description.."
        />
        {errors.description && <p className="err">{errors.description}</p>}
      </div>

      <div
        style={{
          border: "1px solid #e2e8f0",
          padding: "22px",
          marginTop: "18px",
          borderRadius: "14px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
        }}
      >
        <div className="w-100 my-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Room Details (Optional)
          </p>

          <div className="col-md-5 mb-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
              Select available room categories{" "}
              <span style={{ color: "red" }}>*</span>
            </p>

            <div>
              <Select
                options={optionsList?.roomCategories}
                name="roomCategories"
                placeholder="Select Room & Categories"
                value={formData?.roomCategories}
                onChange={(selected) =>
                  handleDropdownChange("roomCategories", selected || [])
                }
                styles={customStyles}
                isDisabled={!edit}
                isMulti
              />
              {errors.roomCategories &&
                formData?.roomCategories?.length === 0 && (
                  <p className="err">{errors.roomCategories}</p>
                )}
            </div>
          </div>
        </div>
        {formData?.roomCategories?.length > 0 && (
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
            Selected Room Categories
          </p>
        )}

        <div className="d-flex ac-js gap-4 mb-3">
          {formData?.roomCategories?.map(({ label, value }, ind) => {
            return (
              <p
                key={value}
                className={`${activeCat?.value === value ? "prim-btn" : "sec border py-1 rounded"} f4 pointer px-4`}
                onClick={() => setActiveId(value)}
              >
                {label}
              </p>
            );
          })}
        </div>

        {activeCat && (
          <>
            <div className="col-md-5 mb-3">
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Rooms Availability <span style={{ color: "red" }}>*</span>
              </p>
              <input
                className="input-box"
                type="number"
                placeholder="Enter Rooms Availability"
                value={room.availability}
                readOnly={!edit}
                onChange={(e) => {
                  if (e.target.value.length > 3) return;
                  updateRoom("availability", e.target.value);
                }}
              />
            </div>

            <div className="d-flex flex-wrap ac-js gap-5">
              <div className="col-md-5">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Room Main Image<span style={{ color: "red" }}>*</span>
                </p>
                {room.primaryImage?.preview || room.primaryImage ? (
                  <div style={{ position: "relative", width: "100px" }}>
                    <img
                      src={room.primaryImage?.preview || room.primaryImage}
                      style={{ width: 100, height: 90, marginTop: 10 }}
                      alt=""
                    />
                    {edit && (
                      <button
                        onClick={() => updateRoom("primaryImage", null)}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: -10,
                          background: "red",
                          color: "white",
                          border: "none",
                          borderRadius: 19,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 20,
                          height: 20,
                        }}
                      >
                        X
                      </button>
                    )}
                  </div>
                ) : (
                  <div>
                    <img
                      src={dummyimage}
                      style={{
                        width: 100,
                        height: 90,
                        marginTop: 10,
                        cursor: "pointer",
                      }}
                      alt=""
                      onClick={() => edit && imgRef.current?.click()}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      className="d-none"
                      ref={imgRef}
                      onChange={handleRoomPrimaryImage}
                    />
                  </div>
                )}
              </div>

              <div>
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Room Images<span style={{ color: "red" }}>*</span>
                </p>
                <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
                  Max Upload Size : 5MB
                </p>
                <DragAndDrop
                  key={key}
                  edit={edit}
                  errors={errors}
                  draggableImages={room.images}
                  setDraggableImages={(v) => updateRoom("images", v)}
                  setDeletedImages={(v) => updateRoom("deletedImageIds", v)}
                />
              </div>
            </div>

            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
              Available Slots<span style={{ color: "red" }}>*</span>
            </p>

            <div className="d-flex flex-wrap gap-3 mb-3 col-md-5">
              {room.timeSlots?.map((s) => {
                {
                  console.log("s", s);
                }
                return (
                  <div
                    key={s.slot}
                    className="input-box d-flex ac-jb gap-3 "
                    style={{ position: "relative" }}
                  >
                    <div className="d-flex ac-js gap-4">
                      <img
                        src={
                          [
                            "Early Morning Slot",
                            "morning_slot",
                            "Afternoon Slot",
                          ].includes(s?.timeslot_type)
                            ? morning_slot
                            : night_slot
                        }
                        style={{ cursor: "pointer", width: "25px" }}
                      />
                      <div>
                        <p className="f3">{s.label}</p>
                        <p className="f2 gray">
                          {s.start_time} - {s.end_time}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="f3">₹{s.basePrice}</p>
                      <p className="f3">Base Price</p>
                    </div>
                    {edit && (
                      <>
                        <img
                          src={new_edit}
                          style={{ cursor: "pointer", width: "20px" }}
                          onClick={() => openSlotPopup(s)}
                        />
                        <CancelIcon
                          onClick={() => handleDeleteSlot(s.slot)}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-10px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </>
                    )}
                  </div>
                );
              })}

              {edit && (
                <button className="submit-btn" onClick={() => openSlotPopup()}>
                  Add Time Slot
                </button>
              )}
            </div>
          </>
        )}
      </div>
      {open && (
        <TimeSlotSelectionPopup
          setOpen={setOpen}
          timeSlots={timeSlots}
          selectedSlot={selectedSlot}
          setSelectedSlot={setSelectedSlot}
          onSave={handleSaveSlot}
          isEditing={editingSlotId !== null}
          sabledSlotIds={(formData?.roomDetails?.[slotCatKey]?.timeSlots || [])
            .map((s) => s.slot)
            .filter((id) => id !== editingSlotId)}
        />
      )}
    </div>
  );
};

export default NearByLocation;
